import { useCallback } from 'react'
import { useSnackbar } from 'notistack'

import { hasOwnPropertyCall } from 'helpers'

export const useOnErrorSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar()
  return useCallback(
    (err: any, secondaryText?: string) => {
      if (!err || hasOwnPropertyCall(err, 'silent')) return
      const message = !secondaryText ? (
        err.toString()
      ) : (
        <div>
          <div>{err.toString()}</div>
          <div style={{ fontSize: '0.9em', opacity: 0.8 }}>{secondaryText}</div>
        </div>
      )
      enqueueSnackbar(message, {
        key: err.toString(),
        variant: 'error',
        preventDuplicate: true,
      })
    },
    [enqueueSnackbar],
  )
}
